import { Box, Tab, Tabs } from "@mui/material";
import { useNavBarTitle } from "components/NavBar";
import { useSearchParams } from "react-router-dom";
import AxesTab from "./AxesTab";
import ColorScalesTab from "./ColorScalesTab";
import { LidarClearanceProvider } from "./LidarClearanceContext";
import SystemsTab from "./SystemsTab";
import t from "./translations";

const TAB_PARAM = "tab";
type TabKey = "systems" | "axes" | "colorScales";

function parseTab(value: string | null): TabKey {
  if (value === "systems" || value === "axes") return value;
  return "colorScales";
}

function LidarClearanceContent() {
  useNavBarTitle(t.PageTitle);
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = parseTab(searchParams.get(TAB_PARAM));

  const handleTabChange = (_: unknown, value: TabKey) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (value === "colorScales") next.delete(TAB_PARAM);
        else next.set(TAB_PARAM, value);
        return next;
      },
      { replace: true }
    );
  };

  return (
    <Box sx={{ p: 2 }} data-testid="lidar-clearance-page">
      <Tabs
        value={tab}
        onChange={handleTabChange}
        data-testid="lidar-clearance-tabs"
      >
        <Tab
          label={t.SystemsTab}
          value="systems"
          data-testid="lidar-clearance-tab.systems"
        />
        <Tab
          label={t.AxesTab}
          value="axes"
          data-testid="lidar-clearance-tab.axes"
        />
        <Tab
          label={t.ColorScalesTab}
          value="colorScales"
          data-testid="lidar-clearance-tab.colorScales"
        />
      </Tabs>
      <Box sx={{ pt: 2 }}>
        {tab === "systems" && <SystemsTab />}
        {tab === "axes" && <AxesTab />}
        {tab === "colorScales" && <ColorScalesTab />}
      </Box>
    </Box>
  );
}

export default function LidarClearance() {
  return (
    <LidarClearanceProvider>
      <LidarClearanceContent />
    </LidarClearanceProvider>
  );
}
